import { action,  observable } from "mobx";
import * as api from '@/services/api';
import {getInitialize} from '@/services/global';
import {getChannel} from '@/utils/channel';
import router from '@/router';

const channel =  getChannel()
class GlobalStore {

  // 客服信息
  @observable customerInfo = {
    url: ''
  }

  @observable channel = channel

  @observable disableText = '我们正在努力适配您的浏览器\n提升系统版本或浏览器版本可立即畅玩'

  @observable toast


  @action.bound bindToast (toast: any) {
    this.toast = toast
  }

  // 获取客服信息
  @action.bound async getCustomerInfo () {
    const customerInfo = await api.getCustomerInfo({});
    if (customerInfo.code === 10000) {
      if(!customerInfo.result.customer_service.skipAddress) {
        this.toast.text('未配置在线客服')
        return false
      }
      this.customerInfo.url = customerInfo.result.customer_service.skipAddress
    }
  }

  @action.bound async getInitialize () {
    const response = await getInitialize();
    if (response.code === 80002) {
      this.disableText = response.msg;
      window.localStorage.setItem('disableText',response.msg)
      router.push({path: '404?stop=true'})
    }
  }

}

export default new GlobalStore();
